<div class="newsletter-wrapper">
  <h1 class="display-4 text-uppercase text-center title-newsletter">
    Newsletter
  </h1>
  
  @if(!loading && !error){
  <p-carousel
    [value]="newsletters"
    [numVisible]="3"
    [numScroll]="3"
    [responsiveOptions]="responsiveOptions"
    circular="true"
    autoplayInterval="8000"
    class="newsletter-carousel"
  >
    <ng-template pTemplate="item" let-post>
      <div class="post-card">
        
        @if(post.imageUrl) {
          <div class="post-image-container">
            <img [src]="post.imageUrl" [alt]="post.name" class="post-image" />
          </div>
        }

        <div class="post-content">
          <h2 class="post-title">{{ post.name }}</h2>
          <p class="post-description">{{ post.description }}</p>

          <a class="post-link" [href]="post.link" target="_blank">
            Leer en Substack →
          </a>
        </div>

      </div>
    </ng-template>
  </p-carousel>
  }
</div>